import type { AxiosInstance } from 'axios';
import { createCrudService, type CrudService } from '../core/crud';
import type { CommissionRule, CommissionRuleCreate, CommissionRuleFilter } from '../data/commissionRule';

export function createCommissionRuleService(client: AxiosInstance) {
  return createCrudService<CommissionRule, CommissionRuleCreate, CommissionRuleFilter>(
    client,
    '/accounting/CommissionRule',
    'id',
  );
}

export type CommissionRuleService = CrudService<CommissionRule, CommissionRuleCreate, CommissionRuleFilter>;
